import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';

import * as NewsModule from 'modules/news';
import * as SystemModule from 'modules/system';

import NewsCard from 'components/NewsCard';

import classes from '../LandingPage.module.scss';

const NewsList: React.FC = () => {
  const { t } = useTranslation();
  const { language } = SystemModule.Hooks.useLanguage();

  const { items } = NewsModule.Hooks.useList({
    name: 'last',
    params: {
      limit: 4
    }
  });

  return (
    <div className={cx(classes.section, 'm-b-0')}>
      <div className={classes.sectionHeader}>
        <div className={classes.sectionTitle}>{t('News')}</div>
        {window.matchMedia('(min-width: 992px)').matches && (
          <Link className={classes.sectionLink} to="/news">{t('All_news')}</Link>
        )}
      </div>
      <div className={classes.sectionContent}>
        <div className={classes.newsList}>
          <div className={classes.newsListInner}>
            {items.map(item => (
              <div key={item.id} className={classes.newsItem}>
                <NewsCard
                  title={get(item, `title[${language}]`)}
                  image={item.image}
                  date={item.date}
                  container={<Link to={`/news/${item.id}`} />}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {!window.matchMedia('(min-width: 992px)').matches && (
        <div className={classes.sectionHeader}>
          <Link className={classes.sectionLink} to="/news">{t('All_news')}</Link>
        </div>
      )}
    </div>
  );
};

export default NewsList;